// import React, { useState } from "react";
// import { deleteAppointment, updateAppointmentStatus } from "../api/appointments";

// export default function AppointmentList({ appointments, onUpdate }) {
//   const [loadingId, setLoadingId] = useState(null);

//   const handleDelete = async (id) => {
//     try {
//       setLoadingId(id);
//       await deleteAppointment(id);
//       onUpdate(); // refresh list in parent (Dashboard)
//     } catch (err) {
//       console.error("Delete failed", err);
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   const handleStatusChange = async (id, status) => {
//     try {
//       setLoadingId(id);
//       await updateAppointmentStatus(id, status);
//       onUpdate(); // refresh list in parent
//     } catch (err) {
//       console.error("Status update failed", err);
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   return (
//     <div>
//       <h3>All Appointments</h3>
//       <ul>
//         {appointments.map((app) => (
//           <li key={app.id} className="mb-2">
//             <span>
//               {app.name} - {app.email} -{" "}
//               {new Date(app.date).toLocaleDateString()} - {app.status}
//             </span>
//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleDelete(app.id)}
//               className="ml-2 px-2 py-1 bg-red-500 text-white rounded"
//             >
//               Delete
//             </button>
//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleStatusChange(app.id, "confirmed")}
//               className="ml-2 px-2 py-1 bg-green-500 text-white rounded"
//             >
//               Confirm
//             </button>
//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleStatusChange(app.id, "cancelled")}
//               className="ml-2 px-2 py-1 bg-gray-500 text-white rounded"
//             >
//               Cancel
//             </button>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { deleteAppointment, updateAppointmentStatus } from "../api/appointments";

// const STATUS_CLASSES = {
//   pending: "bg-yellow-100 text-yellow-700",
//   confirmed: "bg-green-100 text-green-700",
//   completed: "bg-purple-100 text-purple-700",
//   cancelled: "bg-red-100 text-red-700",
// };

// export default function AppointmentList({ appointments, onUpdate }) {
//   const [loadingId, setLoadingId] = useState(null);

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;

//     try {
//       setLoadingId(id);
//       await deleteAppointment(id);
//       onUpdate(); // refresh list in Dashboard
//     } catch (err) {
//       console.error("Delete failed", err);
//       alert("Failed to delete appointment");
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   const handleStatusChange = async (id, status) => {
//     try {
//       setLoadingId(id);
//       await updateAppointmentStatus(id, status);
//       onUpdate(); // refresh list in Dashboard
//     } catch (err) {
//       console.error("Status update failed", err);
//       alert("Failed to update status");
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   // EMPTY STATE
//   if (!appointments || appointments.length === 0) {
//     return (
//       <div className="py-12 text-center text-gray-500">
//         📭 No appointments found
//         <p className="text-sm mt-1">
//           Try adjusting filters or creating a new appointment
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-x-auto">
//       <h3 className="text-lg font-semibold mb-4">All Appointments</h3>

//       {/* TABLE HEADER */}
//       <div className="grid grid-cols-6 gap-4 px-4 py-2 bg-gray-100 text-sm font-semibold text-gray-700 rounded-t">
//         <div>Patient</div>
//         <div>Email</div>
//         <div>Date</div>
//         <div>Status</div>
//         <div className="col-span-2 text-center">Actions</div>
//       </div>

//       {/* TABLE ROWS */}
//       {appointments.map((app) => (
//         <div
//           key={app.id}
//           className={`grid grid-cols-6 gap-4 px-4 py-3 border-b items-center hover:bg-gray-50 transition
//             ${app.status === "cancelled" ? "opacity-60" : ""}
//           `}
//         >
//           {/* Patient */}
//           <div className="font-medium">{app.name}</div>

//           {/* Email */}
//           <div className="text-sm text-gray-600 truncate">{app.email}</div>

//           {/* Date */}
//           <div className="text-sm">
//             {new Date(app.date).toLocaleDateString()}
//           </div>

//           {/* STATUS DROPDOWN */}
//           <div>
//             <select
//               disabled={loadingId === app.id}
//               value={app.status}
//               onChange={(e) =>
//                 handleStatusChange(app.id, e.target.value)
//               }
//               className={`text-xs px-2 py-1 rounded border cursor-pointer ${STATUS_CLASSES[app.status]}`}
//             >
//               <option value="pending">Pending</option>
//               <option value="confirmed">Confirmed</option>
//               <option value="completed">Completed</option>
//               <option value="cancelled">Cancelled</option>
//             </select>
//           </div>

//           {/* ACTION BUTTONS */}
//           <div className="col-span-2 flex gap-2 justify-center">
//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleStatusChange(app.id, "confirmed")}
//               className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
//             >
//               Confirm
//             </button>

//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleDelete(app.id)}
//               className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
//             >
//               Delete
//             </button>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }


// import React, { useState } from "react";
// import {
//   deleteAppointment,
//   updateAppointmentStatus,
//   updateAppointment, // ✅ RESCHEDULE API
// } from "../api/appointments";

// const STATUS_CLASSES = {
//   pending: "bg-yellow-100 text-yellow-700",
//   confirmed: "bg-green-100 text-green-700",
//   completed: "bg-purple-100 text-purple-700",
//   cancelled: "bg-red-100 text-red-700",
// };

// export default function AppointmentList({ appointments, onUpdate }) {
//   const [loadingId, setLoadingId] = useState(null);

//   // 🔁 Reschedule state
//   const [showReschedule, setShowReschedule] = useState(false);
//   const [selectedApp, setSelectedApp] = useState(null);
//   const [newDate, setNewDate] = useState("");
//   const [newTime, setNewTime] = useState("");

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;

//     try {
//       setLoadingId(id);
//       await deleteAppointment(id);
//       onUpdate();
//     } catch (err) {
//       console.error("Delete failed", err);
//       alert("Failed to delete appointment");
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   const handleStatusChange = async (id, status) => {
//     try {
//       setLoadingId(id);
//       await updateAppointmentStatus(id, status);
//       onUpdate();
//     } catch (err) {
//       console.error("Status update failed", err);
//       alert("Failed to update status");
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   // 🔁 RESCHEDULE HANDLER
//   const handleReschedule = async () => {
//     if (!newDate || !newTime) {
//       alert("Please select date and time");
//       return;
//     }

//     try {
//       setLoadingId(selectedApp.id);

//       await updateAppointment(selectedApp.id, {
//         date: newDate,
//         time: newTime,
//       });

//       setShowReschedule(false);
//       setSelectedApp(null);
//       onUpdate();
//     } catch (err) {
//       console.error("Reschedule failed", err);
//       alert("Failed to reschedule appointment");
//     } finally {
//       setLoadingId(null);
//     }
//   };

//   // EMPTY STATE
//   if (!appointments || appointments.length === 0) {
//     return (
//       <div className="py-12 text-center text-gray-500">
//         📭 No appointments found
//         <p className="text-sm mt-1">
//           Try adjusting filters or creating a new appointment
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-x-auto">
//       <h3 className="text-lg font-semibold mb-4">All Appointments</h3>

//       {/* TABLE HEADER */}
//       <div className="grid grid-cols-6 gap-4 px-4 py-2 bg-gray-100 text-sm font-semibold text-gray-700 rounded-t">
//         <div>Patient</div>
//         <div>Email</div>
//         <div>Date</div>
//         <div>Status</div>
//         <div className="col-span-2 text-center">Actions</div>
//       </div>

//       {/* TABLE ROWS */}
//       {appointments.map((app) => (
//         <div
//           key={app.id}
//           className={`grid grid-cols-6 gap-4 px-4 py-3 border-b items-center hover:bg-gray-50 transition
//             ${app.status === "cancelled" ? "opacity-60" : ""}
//           `}
//         >
//           {/* Patient */}
//           <div className="font-medium">{app.name}</div>

//           {/* Email */}
//           <div className="text-sm text-gray-600 truncate">{app.email}</div>

//           {/* Date */}
//           <div className="text-sm">
//             {new Date(app.date).toLocaleDateString()}
//           </div>

//           {/* STATUS DROPDOWN */}
//           <div>
//             <select
//               disabled={loadingId === app.id}
//               value={app.status}
//               onChange={(e) =>
//                 handleStatusChange(app.id, e.target.value)
//               }
//               className={`text-xs px-2 py-1 rounded border cursor-pointer ${STATUS_CLASSES[app.status]}`}
//             >
//               <option value="pending">Pending</option>
//               <option value="confirmed">Confirmed</option>
//               <option value="completed">Completed</option>
//               <option value="cancelled">Cancelled</option>
//             </select>
//           </div>

//           {/* ACTION BUTTONS */}
//           <div className="col-span-2 flex gap-2 justify-center">
//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleStatusChange(app.id, "confirmed")}
//               className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
//             >
//               Confirm
//             </button>

//             <button
//               disabled={loadingId === app.id}
//               onClick={() => {
//                 setSelectedApp(app);
//                 setNewDate(app.date.split("T")[0]);
//                 setNewTime(app.time);
//                 setShowReschedule(true);
//               }}
//               className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
//             >
//               Reschedule
//             </button>

//             <button
//               disabled={loadingId === app.id}
//               onClick={() => handleDelete(app.id)}
//               className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
//             >
//               Delete
//             </button>
//           </div>
//         </div>
//       ))}

//       {/* 🔁 RESCHEDULE MODAL */}
//       {showReschedule && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 w-96">
//             <h3 className="text-lg font-semibold mb-4">
//               Reschedule Appointment
//             </h3>

//             <label className="block mb-2 text-sm">New Date</label>
//             <input
//               type="date"
//               value={newDate}
//               onChange={(e) => setNewDate(e.target.value)}
//               className="w-full border px-3 py-2 rounded mb-3"
//             />

//             <label className="block mb-2 text-sm">New Time</label>
//             <input
//               type="time"
//               value={newTime}
//               onChange={(e) => setNewTime(e.target.value)}
//               className="w-full border px-3 py-2 rounded mb-4"
//             />

//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setShowReschedule(false)}
//                 className="px-3 py-1 text-sm bg-gray-300 rounded"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleReschedule}
//                 className="px-3 py-1 text-sm bg-blue-600 text-white rounded"
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useState } from "react";
import {
  deleteAppointment,
  updateAppointmentStatus,
  updateAppointment,
  cancelAppointment,
} from "../api/appointments";
import { useToast } from "../context/ToastContext";

/**
 * ✅ SUPPORT ALL BACKEND STATUSES
 */
const STATUS_CLASSES = {
  scheduled: "bg-yellow-100 text-yellow-700",
  pending: "bg-yellow-100 text-yellow-700",
  reschedule_requested: "bg-yellow-100 text-yellow-700",
  confirmed: "bg-green-100 text-green-700",
  completed: "bg-purple-100 text-purple-700",
  cancelled: "bg-red-100 text-red-700",
};

const formatDateForInput = (value) => {
  if (!value) return "";
  return String(value).split("T")[0];
};

const formatTimeForInput = (value) => {
  if (!value) return "";
  const raw = String(value);
  return raw.length >= 5 ? raw.slice(0, 5) : raw;
};

const getErrorMessage = (err) =>
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  err?.message ||
  "Something went wrong";

export default function AppointmentList({ appointments, onUpdate, user }) {
  const { addToast } = useToast();
  const [loadingId, setLoadingId] = useState(null);
  const isAdmin = user?.role === "admin";

  const canModifyStatus = (status) =>
    isAdmin && !["cancelled", "completed"].includes(status);

  const canCancel = (status) =>
    !isAdmin && !["cancelled", "completed"].includes(status);

  // 🔁 Reschedule state
  const [showReschedule, setShowReschedule] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [newDate, setNewDate] = useState("");
  const [newTime, setNewTime] = useState("");
  const [savingReschedule, setSavingReschedule] = useState(false);

  // 🗑️ DELETE
  const handleDelete = async (id) => {
    if (!isAdmin) {
      addToast("Only admins can delete appointments", "warning");
      return;
    }
    if (!window.confirm("Delete this appointment?")) return;

    try {
      setLoadingId(id);
      await deleteAppointment(id);
      onUpdate();
    } catch (err) {
      console.error("Delete failed", err);
      addToast("Failed to delete appointment", "error");
    } finally {
      setLoadingId(null);
    }
  };

  // 🔄 STATUS CHANGE (admin only)
  const handleStatusChange = async (id, status) => {
    if (!isAdmin) {
      addToast("Only admins can change appointment status", "warning");
      return;
    }
    try {
      setLoadingId(id);
      await updateAppointmentStatus(id, status);
      onUpdate();
      addToast("Status updated", "success");
    } catch (err) {
      console.error("Status update failed", err);
      addToast(err.message || "Failed to update status", "error");
    } finally {
      setLoadingId(null);
    }
  };

  const handleCancel = async (id) => {
    if (!window.confirm("Cancel this appointment?")) return;
    try {
      setLoadingId(id);
      await cancelAppointment(id);
      onUpdate();
      addToast("Appointment cancelled", "success");
    } catch (err) {
      console.error("Cancel failed", err);
      addToast(err.message || "Failed to cancel appointment", "error");
    } finally {
      setLoadingId(null);
    }
  };

  const openReschedule = (app) => {
    setSelectedApp(app);
    setNewDate(formatDateForInput(app.appointment_date || app.date));
    setNewTime(formatTimeForInput(app.appointment_time || app.time));
    setShowReschedule(true);
  };

  const closeReschedule = () => {
    setShowReschedule(false);
    setSelectedApp(null);
    setNewDate("");
    setNewTime("");
    setSavingReschedule(false);
  };

  // 🔁 RESCHEDULE
  const handleReschedule = async () => {
    if (!selectedApp?.id) return;
    if (!newDate || !newTime) {
      addToast("Please select date and time", "warning");
      return;
    }

    try {
      setSavingReschedule(true);
      setLoadingId(selectedApp.id);

      await updateAppointment(selectedApp.id, {
        date: newDate,
        time: newTime,
      });

      closeReschedule();
      await onUpdate();
      addToast(
        isAdmin
          ? "Appointment rescheduled successfully"
          : "Reschedule request submitted",
        "success"
      );
    } catch (err) {
      console.error("Reschedule failed", err);
      addToast(getErrorMessage(err) || "Failed to reschedule appointment", "error");
    } finally {
      setSavingReschedule(false);
      setLoadingId(null);
    }
  };

  // 📭 EMPTY STATE
  if (!appointments || appointments.length === 0) {
    return (
      <div className="py-12 text-center text-slate-500 dark:text-slate-400">
        📭 No appointments found
        <p className="text-sm mt-1">
          Try adjusting filters or creating a new appointment
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <h3 className="text-lg font-semibold mb-4 text-slate-900 dark:text-slate-100">All Appointments</h3>

      {/* TABLE HEADER */}
      <div className="grid grid-cols-6 gap-4 px-4 py-2 bg-slate-100 dark:bg-slate-800/80 text-sm font-semibold text-slate-700 dark:text-slate-300 rounded-t">
        <div>Patient</div>
        <div>Email</div>
        <div>Date</div>
        <div>Status</div>
        <div className="col-span-2 text-center">Actions</div>
      </div>

      {/* TABLE ROWS */}
      {appointments.map((app) => (
        <div
          key={app.id}
          className={`grid grid-cols-6 gap-4 px-4 py-3 border-b border-slate-200 dark:border-slate-700 items-center hover:bg-slate-50 dark:hover:bg-slate-800/50 transition text-slate-800 dark:text-slate-200
            ${app.status === "cancelled" ? "opacity-60" : ""}
          `}
        >
          {/* Patient */}
          <div className="font-medium">{app.name}</div>

          {/* Email */}
          <div className="text-sm text-slate-600 dark:text-slate-400 truncate">{app.email}</div>

          {/* Date */}
          <div className="text-sm">
            {new Date(app.date).toLocaleDateString()}
          </div>

          {/* STATUS */}
          <div>
            {isAdmin ? (
              <select
                disabled={loadingId === app.id || !canModifyStatus(app.status)}
                value={app.status}
                onChange={(e) => handleStatusChange(app.id, e.target.value)}
                className={`text-xs px-2 py-1 rounded border cursor-pointer ${
                  STATUS_CLASSES[app.status] || "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400"
                }`}
              >
                <option value="scheduled">Scheduled</option>
                <option value="pending">Pending</option>
                <option value="reschedule_requested">Reschedule Requested</option>
                <option value="confirmed">Confirmed</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </select>
            ) : (
              <span
                className={`inline-block text-xs px-2 py-1 rounded capitalize ${
                  STATUS_CLASSES[app.status] || "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400"
                }`}
              >
                {app.status?.replace(/_/g, " ") || "pending"}
              </span>
            )}
          </div>

          {/* ACTION BUTTONS */}
          <div className="col-span-2 flex gap-2 justify-center flex-wrap">
            {isAdmin && canModifyStatus(app.status) && (
              <button
                disabled={loadingId === app.id}
                onClick={() => handleStatusChange(app.id, "confirmed")}
                className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
              >
                Confirm
              </button>
            )}

            {!isAdmin && canCancel(app.status) && (
              <button
                disabled={loadingId === app.id}
                onClick={() => handleCancel(app.id)}
                className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
              >
                Cancel
              </button>
            )}

            <button
              disabled={loadingId === app.id || app.status === "cancelled"}
              onClick={() => openReschedule(app)}
              className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
            >
              Reschedule
            </button>

            {isAdmin && (
              <button
                disabled={loadingId === app.id}
                onClick={() => handleDelete(app.id)}
                className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
              >
                Delete
              </button>
            )}
          </div>
        </div>
      ))}

      {/* 🔁 RESCHEDULE MODAL */}
      {showReschedule && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="health-card rounded-xl p-6 w-full max-w-md shadow-2xl dark:shadow-glass-lg-dark">
            <h3 className="text-lg font-semibold mb-1 text-slate-900 dark:text-slate-100">
              Reschedule Appointment
            </h3>
            {selectedApp && (
              <p className="text-sm text-slate-500 dark:text-slate-400 mb-4">
                {selectedApp.name || selectedApp.patient_name || "Patient"} ·{" "}
                {selectedApp.doctor_name || "Doctor"}
              </p>
            )}

            <label className="block mb-2 text-sm text-slate-700 dark:text-slate-300">New Date</label>
            <input
              type="date"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              className="health-input mb-3 w-full"
              disabled={savingReschedule}
            />

            <label className="block mb-2 text-sm text-slate-700 dark:text-slate-300">New Time</label>
            <input
              type="time"
              value={newTime}
              onChange={(e) => setNewTime(e.target.value)}
              className="health-input mb-4 w-full"
              disabled={savingReschedule}
            />

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={closeReschedule}
                disabled={savingReschedule}
                className="px-4 py-2 text-sm bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-200 rounded-lg disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleReschedule}
                disabled={savingReschedule || !newDate || !newTime}
                className="px-4 py-2 text-sm bg-health-600 hover:bg-health-700 text-white rounded-lg disabled:opacity-50 min-w-[88px]"
              >
                {savingReschedule ? "Saving…" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
